import SeoHead from '../../components/feature/SeoHead';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ZoneMap from './components/ZoneMap';
import ZoneCityGrid from './components/ZoneCityGrid';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Todas las Zonas de Cobertura | Desguace Barcelona',
  description: 'Desguace Barcelona cubre más de 30 ciudades en toda la provincia. Recogida gratuita en Barcelonès, Vallès, Baix Llobregat, Maresme y más comarcas.',
  url: `${siteUrl}/zonas`,
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: 'Zonas de Cobertura', item: `${siteUrl}/zonas` },
    ],
  },
};

export default function ZonasPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Zonas de Cobertura Desguace Barcelona | +30 Ciudades | Recogida Gratis"
        description="Desguace Barcelona cubre más de 30 ciudades en toda la provincia. Barcelonès, Vallès Occidental, Baix Llobregat, Maresme y más. Recogida gratuita a domicilio."
        keywords="zonas desguace Barcelona, cobertura desguace Barcelona, recogida coches Barcelona provincia, desguace área metropolitana Barcelona"
        canonical={`${siteUrl}/zonas`}
        jsonLd={jsonLd}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/5a1f4be0915c42d81695754cb8b7cc87.jpg"
            alt="Vista aérea del área metropolitana de Barcelona"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-5 py-2 mb-6">
            <i className="ri-map-pin-line text-[#ff6b35]"></i>
            <span className="text-white text-sm font-medium">Cobertura completa en Barcelona</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Todas las Zonas de<br />
            <span className="text-[#ff6b35]">Desguace Barcelona</span>
          </h1>
          <p className="text-xl text-white/85 max-w-3xl mx-auto leading-relaxed mb-10">
            Cubrimos más de 30 ciudades en toda la provincia de Barcelona. Recogida gratuita a domicilio, tasación inmediata y pago al instante en cualquier zona.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20tasar%20mi%20coche%20gratis"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#25D366] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#1da851] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center"
            >
              <i className="ri-whatsapp-line mr-2 text-xl"></i>
              Tasación Gratis por WhatsApp
            </a>
            <a
              href="tel:+34932932913"
              className="bg-white/15 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer inline-flex items-center"
            >
              <i className="ri-phone-line mr-2 text-xl"></i>
              932 932 913
            </a>
          </div>
        </div>
      </section>

      {/* Map + Comarcas */}
      <ZoneMap />

      {/* City Grid */}
      <ZoneCityGrid />

      {/* CTA */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-[#ff6b35] to-[#ff8c5a] rounded-2xl shadow-xl p-12 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              ¿No encuentras tu zona? ¡Llámanos igualmente!
            </h2>
            <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
              Estamos ampliando constantemente nuestra cobertura. Si tu ciudad no aparece en la lista, contáctanos y seguramente podamos ayudarte.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20saber%20si%20cubrís%20mi%20zona"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#25D366] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#1da851] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center"
              >
                <i className="ri-whatsapp-line mr-2 text-xl"></i>
                Consultar por WhatsApp
              </a>
              <a
                href="tel:+34932932913"
                className="bg-white text-[#ff6b35] px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center"
              >
                <i className="ri-phone-line mr-2 text-xl"></i>
                Llamar: 932 932 913
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
